<!-------------------------------Edit Mode in Horizontal Images ---------------------------->
<ng-container *ngIf="editable">
  <div class="row top-dialog-cropper">
    <div class="close-dialog" (click)="onCloseClick()">
      <mat-icon class="viewer-close-button">close</mat-icon>
    </div>
    <div class="cropper-tools">
      <span (click)="rotateLeft()">
        <mat-icon class="rotate-button left">rotate_left</mat-icon>
      </span>
      <span (click)="rotateRight()">
        <mat-icon class="rotate-button right">rotate_right</mat-icon>
      </span>
    </div>
    <div class="generic-small-btn done" (click)="saveImage()">Done</div>
    <div class="col-12 cropper-title">
      <span>
        <p>Edit Logo Photo</p>
      </span>
    </div>
  </div>
  <div class="cropper-area" [style.opacity]="cropperOpacity">
    <div class="image-container">
      <img #image [src]="imageSource" alt="Image viewer" />
    </div>
  </div>
</ng-container>

<!-------------------------------View Mode for Horizontal Images ---------------------------->
<ng-container *ngIf="!editable">
  <div class="row top-dialog-cropper contrast justify-content-end">
    <div class="contrast">
      <div (click)="onCloseClick()">
        <mat-icon class="viewer-close-button contrast">close</mat-icon>
      </div>
    </div>
  </div>
  <div [className]="aspectRatio === aspectRatios.HORIZONTAL ? 'horizontal-viewer' : 'vertical-viewer'">
    <img [className]="aspectRatio === aspectRatios.HORIZONTAL ? 'horizontal-image' : 'vertical-image'" [src]="imageSource" alt="Image viewer" />
  </div>
  <div class="row top-dialog-cropper contrast" style="justify-content: center; flex-direction: column; align-items: center">
    <span (click)="deletePhoto()">
      <img class="view-tools" src="../../../../assets/images/icons/media-delete.svg" />
    </span>
    <span class="remove-text">REMOVE PHOTO</span>
  </div>
</ng-container>
